"use client";

import type { FieldValues, Path } from "react-hook-form";

import { useState } from "react";
import { useFormContext } from "react-hook-form";

function useInquiryFieldError<T extends FieldValues>() {
  const { formState } = useFormContext<T>();
  const { errors, isSubmitted, touchedFields } = formState;
  const [attemptedStepContinue, setAttemptedStepContinue] = useState(false);

  function shouldShowError(field: Path<T>) {
    const fieldKey = field as string;
    const isTouched = Boolean(
      (touchedFields as Record<string, boolean | undefined>)[fieldKey],
    );
    const error = errors[field as keyof typeof errors];
    return Boolean(
      (isTouched || isSubmitted || attemptedStepContinue) && error,
    );
  }

  return { errors, setAttemptedStepContinue, shouldShowError };
}

export { useInquiryFieldError };
